/* Flora: reveals headings, product cards and customer quotes as they scroll into view.
   Only elements that start below the screen are animated, so nothing visible on load ever blinks. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = '.main-content .kicker-flourished, .main-content .product-grid-item, .main-content .index__column';
  var queue = [], timer = null;

  // Skip anything inside a sideways slider: it may never scroll into view vertically.
  function inSlider(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var ox = getComputedStyle(p).overflowX;
      if ((ox === 'auto' || ox === 'scroll' || ox === 'hidden') && p.scrollWidth > p.clientWidth + 4) return true;
    }
    return false;
  }

  function finish(el) {
    el.classList.remove('fl-rv', 'fl-in');
    el.style.transitionDelay = '';
  }

  function flush() {
    timer = null;
    queue.sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top || a.getBoundingClientRect().left - b.getBoundingClientRect().left; });
    queue.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 80, 400) + 'ms';
      el.classList.add('fl-in');
      setTimeout(function () { finish(el); }, 1500 + Math.min(i * 80, 400));
    });
    queue = [];
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      queue.push(e.target);
    });
    if (queue.length && !timer) timer = setTimeout(flush, 16); // a timer, not a frame callback, so a paused tab can never leave cards hidden
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

  function scan(root) {
    var vh = window.innerHeight;
    (root.querySelectorAll ? root.querySelectorAll(SEL) : []).forEach(function (el) {
      if (el.hasAttribute('data-fl-seen')) return;
      el.setAttribute('data-fl-seen', '');
      if (el.getBoundingClientRect().top < vh * 0.92) return; // already on screen: leave it alone
      if (inSlider(el)) return;
      el.classList.add('fl-rv');
      io.observe(el);
    });
  }

  function start() {
    scan(document);
    // Collection filters and sorting load new cards without a page reload
    var main = document.querySelector('.main-content');
    if (main) new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n.parentElement || n); }); });
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Pre-order badge from the Stoq app: same wording as the menu, and Arabic on the Arabic site */
(function () {
  var ar = /^ar/.test(document.documentElement.lang || '');
  var label = ar ? 'طلب مسبق' : 'Pre-order';
  var pending = false;
  function fix() {
    pending = false;
    document.querySelectorAll('.restock-rocket-preorder-badge').forEach(function (b) {
      if (b.textContent.trim() !== label && /pre-?order/i.test(b.textContent)) b.textContent = label;
    });
  }
  function soon() { if (!pending) { pending = true; setTimeout(fix, 60); } }
  function start() { fix(); new MutationObserver(soon).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
